import type { ProductDescriptionResult } from './model';

export type ProductDescriptionAction =
  | ProductDescriptionsRequested
  | ProductDescriptionsReceived
  | ProductDescriptionsFailed
  | ProductDescriptionsTimeouted;

export function productDescriptionsRequested() {
  return {
    type: 'PRODUCT_DESCRIPTIONS_REQUESTED' as const,
  };
}
export type ProductDescriptionsRequested = ReturnType<typeof productDescriptionsRequested>;

export function productDescriptionsReceived(data: ProductDescriptionResult) {
  return {
    type: 'PRODUCT_DESCRIPTIONS_RECEIVED' as const,
    data,
  };
}
export type ProductDescriptionsReceived = ReturnType<typeof productDescriptionsReceived>;

export function productDescriptionsFailed() {
  return {
    type: 'PRODUCT_DESCRIPTIONS_FAILED' as const,
  };
}
export type ProductDescriptionsFailed = ReturnType<typeof productDescriptionsFailed>;

export function productDescriptionsTimeouted() {
  return {
    type: 'PRODUCT_DESCRIPTIONS_TIMEOUTED' as const,
  };
}
export type ProductDescriptionsTimeouted = ReturnType<typeof productDescriptionsTimeouted>;
